import { toFormat } from 'core/classes/helpers/DateHelper'

const DATE_TEMPLATE = 'DD MMM YYYY'

/**
 * Formats an activity date string (ISO or locale) as e.g. `06 Nov 2025`.
 * Uses `toFormat` (dayjs, no UTC-offset shift) so midnight-ISO date-only values
 * don't roll back a day in negative timezones. Empty input → `''`.
 */
export const formatActivityDate = (value: string): string => {
  if (!value) {
    return ''
  }

  return toFormat(value, DATE_TEMPLATE) || ''
}

const AMOUNT_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

/**
 * Formats a numeric amount (string or number) as `$3,524.85`. When `withSign`
 * is false the `$` is stripped (used for local-currency amounts). Empty / NaN → `''`.
 */
export const formatAmount = (value: string | number, withSign: boolean): string => {
  if (value === '' || value === null || value === undefined) {
    return ''
  }

  const numeric = Number(value)

  if (Number.isNaN(numeric)) {
    return ''
  }

  const formatted = AMOUNT_FORMATTER.format(numeric)

  return withSign ? formatted : formatted.replace('$', '')
}
